
type Result = (val: number) => number;

const useChartYMultiplier = (
  settings: ChartSettings
): Result => {
  return (value: number): number => {
    if (settings.yMultipliers) {
      for (const multiplier of settings.yMultipliers) {
        if (value > multiplier.min && value <= multiplier.max) {
          value = (value - multiplier.min) / (multiplier.max - multiplier.min) * multiplier.multiplier;
        }
      }
    }

    return value;
  };
};

export default useChartYMultiplier;
